import { useSelector } from "react-redux";
import PrivateRoutes from "./PrivateRoutes";
import PublicRoutes from "./PublicRoutes";

export default function Routing() {
  const {token, user} = useSelector((state) => state.auth);
  return ((token && user?.id) ? <PrivateRoutes /> : <PublicRoutes />)
  
}
